import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // npm install jwt-decode

const PrivateRoute = ({ element, allowedRoles }) => {
  const [authState, setAuthState] = useState({
    loading: true,
    authorized: false,
    reason: null,
  });

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      setAuthState({ loading: false, authorized: false, reason: "no-token" });
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        localStorage.removeItem("token");
        setAuthState({ loading: false, authorized: false, reason: "expired" });
        return;
      }

      const userRole = decoded.role || localStorage.getItem("role");

      if (allowedRoles && !allowedRoles.includes(userRole)) {
        setAuthState({
          loading: false,
          authorized: false,
          reason: "unauthorized",
        });
      } else {
        setAuthState({ loading: false, authorized: true });
      }
    } catch (error) {
      console.error("Invalid token:", error.message);
      localStorage.removeItem("token");
      setAuthState({ loading: false, authorized: false, reason: "invalid" });
    }
  }, [allowedRoles]);

  if (authState.loading) {
    return <div>Loading...</div>;
  }

  if (!authState.authorized) {
    if (authState.reason === "unauthorized") {
      return <Navigate to="/unauthorized" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default PrivateRoute;
